<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  html, body{
    font-family: 'Monda', sans-serif;
    /*font-family: 'Barlow Condensed', sans-serif;*/
    /*font-family: 'Rokkitt', serif;*/
    /*font-family: 'Varela Round', sans-serif;*/
    /*font-family: 'Arvo', serif;*/
    /*font-family: 'Roboto Mono', monospace;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 12px;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden;
  }

  .row{
    margin: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue